import BaseFolderType from 'owa-service/lib/contract/BaseFolderType';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import FindFolderResponseMessage from 'owa-service/lib/contract/FindFolderResponseMessage';
import findFolders from 'owa-mail-store/lib/services/findFolders';
import Folder from 'owa-mail-store/lib/store/schema/Folder';
import FolderId from 'owa-service/lib/contract/FolderId';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import FolderStore from 'owa-mail-store/lib/store/schema/FolderStore';
import FolderType from 'owa-service/lib/contract/Folder';
import getSelectedFolderId from 'owa-mail-store/lib/utils/getSelectedFolderId';
import loadFavorites from './favorites/loadFavorites';
import selectDefaultFolder from './selectDefaultFolder';
import { action } from 'satcheljs/lib/legacy';
import { getStore } from 'owa-mail-store/lib/store/Store';

const HIDDEN_FOLDER_EXTENDED_PROPERTY_TAG = '0x10f4';

const assign = require('object-assign');

let loadFoldersInProgress = false;

function getIsFolderHidden(item: BaseFolderType): boolean {
    if (item.ExtendedProperty) {
        for (let i = 0; i < item.ExtendedProperty.length; i++) {
            const extendedProperty = item.ExtendedProperty[i];
            if (
                extendedProperty.ExtendedFieldURI.PropertyTag ===
                HIDDEN_FOLDER_EXTENDED_PROPERTY_TAG
            ) {
                return JSON.parse(extendedProperty.Value);
            }
        }
    }

    return false;
}

function addFolderToStore(state: FolderStore, item: BaseFolderType) {
    const folderId = item.FolderId.Id;
    const distinguishedFolderIdName = item.DistinguishedFolderId
        ? <DistinguishedFolderIdName>item.DistinguishedFolderId
        : undefined;

    const folder: Folder = assign(
        {
            childFolderIds: [],
            distinguishedFolderId: distinguishedFolderIdName,
            UnreadCount: (<FolderType>item).UnreadCount,
            TotalCount: item.TotalCount,
            isHidden: getIsFolderHidden(item),
        },
        item
    );

    state.folderTable.set(folderId, folder);
}

const addFoldersFromFindFolder = action('addFoldersFromFindFolder')(
    function addFoldersFromFindFolder(
        state: FolderStore,
        responseMessage: FindFolderResponseMessage
    ) {
        if (!responseMessage) {
            return;
        }

        const folderIds: FolderId[] = [];

        // clear what we currently store
        state.folderTable.clear();

        // process all of the folders in the response
        responseMessage.RootFolder.Folders.forEach((item: BaseFolderType) => {
            addFolderToStore(state, item);
            folderIds.push(item.FolderId);
        });

        // process the ParentFolder from the response, and set it as the root
        addFolderToStore(state, responseMessage.RootFolder.ParentFolder);
        state.rootFolder = state.folderTable.get(
            responseMessage.RootFolder.ParentFolder.FolderId.Id
        );

        // set up all of the parent-child folder relations
        folderIds.forEach((folderId: FolderId) => {
            const folder = state.folderTable.get(folderId.Id);
            const parentFolder = state.folderTable.get(folder.ParentFolderId.Id);

            if (parentFolder && !folder.isHidden) {
                parentFolder.childFolderIds.push(folderId.Id);
            }
        });
    }
);

/*
 * Invokes Loads the folders for the folder list
 */
export default action('loadFolders')(function loadFolders() {
    if (loadFoldersInProgress) {
        return;
    }
    const { folders } = getStore();

    loadFoldersInProgress = true;
    const rootFolderId = folderNameToId('msgfolderroot');
    findFolders(rootFolderId).then(findFolderResponse => {
        addFoldersFromFindFolder(folders, findFolderResponse);

        // Check if we have something selected.
        const selectedFolderId = getSelectedFolderId();
        const folder: Folder = selectedFolderId ? folders.folderTable.get(selectedFolderId) : null;

        // And that what we have selected is actually a valid folder,
        // not an old one that has been removed and not under deletedItems.
        if (!folder || folder.ParentFolderId.Id === folderNameToId('deleteditems')) {
            // Otherwise selected the default one (inbox).
            selectDefaultFolder();
        }

        loadFoldersInProgress = false;

        loadFavorites();
    });
});
